import React, { useEffect, useState } from 'react';
import NewNavigationMenu from './NavigationDrawer';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const NavigationContainer = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const { block, additionalHeaderLinks } = props;
  // @ts-expect-error: Ignore type error for contentLinks selector
  const contentLinks = useSelector((state) => state.navigation.contentLinks);

  const handleOpenMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <>
      <button
        onClick={handleOpenMenu}
        className="flex gap-2 items-center navbar-menu-icon__wrapper"
        aria-label={translate('menu.open-navigation')}
        aria-controls="main-navigation-menu"
        title={translate('menu.open-navigation')}
      >
        <span className="navbar-menu-icon"></span>
        <span className="hidden lg:block">
          {translate('navigation.ourproducts')}
        </span>
      </button>
      <NewNavigationMenu
        isOpen={menuOpen}
        setIsOpen={setMenuOpen}
        links={contentLinks}
        additionalHeaderLinks={additionalHeaderLinks}
        block={block}
      />
    </>
  );
};

export default NavigationContainer;
